import { ReactFlowProvider } from "react-flow-renderer";
import React, { useEffect } from "react";
import ReactFlowGraph from "./ReactFlowGraph";
import { Cursor } from "../../fstn/cursor";
import { Network } from "../../fstn/network";
import { getAnalytics, logEvent } from "firebase/analytics";
import { ActionFactory } from "../../fstn/actionFactory";
import { IDebugController } from "../../fstn/debugController";
import {Box} from "@mui/material";
import {SideBar, ISideBarTab} from "../sidebar/SideBar";
import SelectedInspector from "./inspector/SelectedInspector";
import makeStyles from "@mui/styles/makeStyles";
import GroupManager from "./groups/GroupManager";
import {connect} from "react-redux";
import ScriptSequence from "./scriptSequence/ScriptSequence";
import {Shortcuts} from "./shortcuts/Shortcuts";
import {ShortcutHandler} from "./shortcuts/ShortcutHandler";

const useStyles = makeStyles(() => ({
    content: {
        width: "100%"
    }
}));
const sideBarTabs: ISideBarTab[] = [
    { name: "Details", type: SelectedInspector },
    { name: "Groups", type: GroupManager },
    { name: "Script Sequence", type: ScriptSequence },
    { name: "Shortcuts", type: Shortcuts }
];
interface IProps
{
    cursor: Cursor
    debugController: IDebugController | undefined
    factory: ActionFactory
    network: Network
}
function Graph({cursor, debugController, factory, network}: IProps)
{
    const classes = useStyles();

    useEffect(() =>
    {
        logEvent(getAnalytics(), "page_view", {
            page_location: "/graph"
        });
    }, []);
    return (
        <Box className={classes.content} display="flex" flexGrow={1}>
            <SideBar tabs={sideBarTabs}/>
            <ShortcutHandler/>
            <Box display="flex" flexDirection="column" flexGrow={1}>
                <ReactFlowProvider>
                    <ReactFlowGraph cursor={cursor} debugController={debugController} factory={factory} network={network}/>
                </ReactFlowProvider>
            </Box>
        </Box>
    );
}
const mapStateToProps = (store: never) => ({
});

export default connect(mapStateToProps, {
})(Graph);
